import React, { useState } from 'react';
import { deleteUser } from './api';
import './DeleteUserModal.css';

const DeleteUserModal = ({ user, onUserDeleted, onCancel }) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState('');

  const handleDelete = async () => {
    setError('');
    setIsDeleting(true);

    try {
      await deleteUser(user.id);
      onUserDeleted();
    } catch (error) {
      console.error('Error deleting user:', error);
      if (error.response?.data?.error) {
        setError(error.response.data.error);
      } else {
        setError('Failed to delete user');
      }
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <div className="delete-user-modal-overlay">
      <div className="delete-user-modal">
        <h3>Delete User</h3>
        <div className="warning-message">
          <strong>⚠️ Warning: This action cannot be undone!</strong>
        </div>
        
        <div className="user-info">
          <p><strong>Username:</strong> {user.username}</p>
          <p><strong>Email:</strong> {user.email}</p>
          <p><strong>Name:</strong> {user.first_name} {user.last_name}</p>
          {user.is_admin && <p><strong>Role:</strong> Admin User</p>}
        </div>

        <p className="confirmation-text">
          Are you sure you want to delete this user? This will permanently remove 
          their account and all associated data.
        </p>

        {error && <div className="error-message">{error}</div>}

        <div className="modal-buttons">
          <button 
            onClick={handleDelete} 
            disabled={isDeleting}
            className="delete-btn"
          >
            {isDeleting ? 'Deleting...' : 'Delete User'}
          </button>
          <button 
            onClick={onCancel} 
            disabled={isDeleting}
            className="cancel-btn"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteUserModal;
